import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

const TimeUnit = ({ value, label }) => (
  <Box sx={{ textAlign: "center" }}>
    <Box
      sx={{
        width: { xs: 30, sm: 48, md: 50 },
        height: { xs: 38, sm: 55, md: 60 },
        borderRadius: { xs: "10px", sm: "12px", md: "12px" },
        background: "#e6e6e687",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",

        boxShadow: `
          6px 6px 6px rgba(0,0,0,0.12),
          -2px -2px 10px rgba(225, 225, 225, 0.39)
        `,

        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        key={value}
        sx={{
          fontSize: { xs: "0.8rem", sm: "1.2rem", md: "1.2rem" },
          fontWeight: 700,
          color: "#333",
          position: "absolute",
          animation: "softPulse 0.55s ease",

          "@keyframes softPulse": {
            "0%": { transform: "scale(1)" },
            "40%": { transform: "scale(1.15)" },
            "100%": { transform: "scale(1)" },
          },
        }}
      >
        {value}
      </Box>
    </Box>

    <Typography
      sx={{
        mt: 0.8,
        fontSize: { xs: "0.55rem", sm: "0.75rem", md: "0.85rem" },
        fontWeight: 500,
        letterSpacing: "0.4px",
        color: "#666",
        fontFamily: "Story",
      }}
    >
      {label}
    </Typography>
  </Box>
);

export default function CountdownNeumorphism({ targetDate }) {
  const [time, setTime] = useState({});

  useEffect(() => {
    const interval = setInterval(() => {
      const now = Date.now();
      const diff = new Date(targetDate).getTime() - now;

      if (diff <= 0) {
        clearInterval(interval);
        setTime({ ended: true });
        return;
      }

      const days = String(Math.floor(diff / (1000 * 60 * 60 * 24))).padStart(2, "0");
      const hours = String(Math.floor((diff / (1000 * 60 * 60)) % 24)).padStart(2, "0");
      const minutes = String(Math.floor((diff / (1000 * 60)) % 60)).padStart(2, "0");
      const seconds = String(Math.floor((diff / 1000) % 60)).padStart(2, "0");

      setTime({ days, hours, minutes, seconds });
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  if (time.ended) {
    return (
      <Typography
        sx={{
          color: "#d32f2f",
          fontWeight: 700,
          textAlign: "center",
          fontSize: { xs: "0.9rem", md: "1.1rem" },
        }}
      >
        Vente flash terminée
      </Typography>
    );
  }

  return (
    <Box sx={{ textAlign: "center", mt: 2 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "row", sm: "row" },
          flexWrap: "wrap",
          gap: { xs: 1.5, sm: 3 },
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <TimeUnit value={time.days} label="Jours" />
        <TimeUnit value={time.hours} label="Heures" />
        <TimeUnit value={time.minutes} label="Minutes" />
        <TimeUnit value={time.seconds} label="Secondes" />
      </Box>
    </Box>
  );
}